export const COMMERCIAL_WHATSAPP_DISPLAY = '+55 41 99510-1123'
export const COMMERCIAL_WHATSAPP_URL = 'https://wa.me/5541995101123'
export const WHATSAPP_GROUP_URL = 'https://chat.whatsapp.com/KPDY7G9dls55pnTDyJ0Mxg'
export const DISCORD_INVITE_URL = 'https://discord.gg/K7fh726hC8'
